import { useCallback } from 'react';
import type { Permission } from '#shared/types';
import { can } from '#client/lib/permissions';
import { useAuth } from '#client/providers/AuthProvider';

/**
 * Permission check bound to the signed-in user.
 *
 *     const can = useCan();
 *     {can('patient.create') && <Button>Register patient</Button>}
 *
 * Returns a stable callback so it can sit in a dependency array without
 * re-triggering effects on every render.
 */
export function useCan(): (capability: Permission) => boolean {
  const { user } = useAuth();
  return useCallback((capability: Permission) => can(user, capability), [user]);
}
